import { z } from "zod";

// Role tag for gallery photos. Drives which surface the UI shows them on.
//   poster    — the canonical 9:16 series poster (one per series, required)
//   hero      — wide hero/banner for detail-page header (16:9, optional)
//   still     — production stills from the show (galleryable)
//   keyart    — promotional key art / cover variations
//   card      — preview card / social-share card (1.91:1)
//   social    — square crop for Instagram/grid surfaces
//   thumbnail — episode-specific frame thumbnail
export const galleryRoleSchema = z.enum([
  "poster",
  "hero",
  "still",
  "keyart",
  "card",
  "social",
  "thumbnail",
]);
export type GalleryRole = z.infer<typeof galleryRoleSchema>;

export const galleryImageSchema = z.object({
  url: z.string().url(),
  role: galleryRoleSchema,
  alt: z.string().optional(),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  bytes: z.number().int().positive().optional(),
  // R2 object key — needed for signed-URL refresh / deletion.
  r2Key: z.string().optional(),
  uploadedBy: z.string().optional(),
  uploadedAt: z.coerce.date().optional(),
});
export type GalleryImage = z.infer<typeof galleryImageSchema>;
